/**
 * Programs Endpoints
 * SUPERADMIN: Program management APIs
 */
export const PROGRAMS_ENDPOINTS = {
  list: 'admin/get-programs',
  create: 'admin/create-program',
  update: 'admin/update-program',
  delete: 'programs/delete-programs',
  getConfig: 'programs/get-programs-configuration',
  updateStatus: 'admin/update-program-status',
  programLogin: 'admin/program-login',

  getAppInfo: 'app-content/get-app-info',
  createAppInfo: 'app-content/create-app-info',
  updateAppInfo: 'app-content/update-app-info',
  generateApk: 'app-content/generate-apk',
  requestApk: 'app-content/generate-request',
  applog : 'app-content/get-app-info-logs',
};
